import { Component, OnInit } from '@angular/core';
import { LoadJsService } from '../../load-js/load-js.service';

import { User } from '../../_models/user';
import { UserService} from '../../_services/user.service';
import { AuthenticationService } from '../../_services/authentication.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})

export class DashboardComponent implements OnInit {
  currentUser: User;
  userLogin = [];
  personnames = ['Yallaling', '   ', '  Goudar  '];
  jos = '';

  constructor(
    private loadjs: LoadJsService,
    private userService: UserService,
    private authenticationService: AuthenticationService
  ) { 
  
    this.currentUser = this.authenticationService.currentUserValue;
    this.jos = this.currentUser.name; 
  }
  
  private loadScripts() {
    this.loadjs.loadScriptJs();
    JSON.parse(localStorage.getItem('userlogin'));
    // console.log(localStorage.getItem('currentUser'));
    //console.log(localStorage.getItem('userlogin'));
  }

  ngOnInit() {
    this.loadScripts();
    this.userLogin = this.currentUser['data'];
  }

}
